import initSlider from '../libs/initSlider';
import loadYoutubeScript from '../libs/loadYoutubeScript';
import changeActiveSlide from '../changeActiveSlide';
import loadPicture from '../loadPicture';
import { LOADER } from '../app';

document.addEventListener('DOMContentLoaded', (e) => {
  const PAGE = 'index';

  if (window.scrollY > 1000) {
    isYoutubeLoaded = true;
    loadYoutubeScript();
  }

  window.addEventListener('scroll', () => {
    if (isYoutubeLoaded) return;

    if (window.scrollY > 1000) {
      isYoutubeLoaded = true;
      loadYoutubeScript();
    }
  });

  const mediaSlider = initSlider('[data-media-slider]', mediaSliderOptions);
  const crmSlider = initSlider('[data-crm-slider]', crmSliderOptions);
  const appSlider = initSlider('[data-app-slider]', appSliderOptions);

  appSlider.on('click', (swiper) => {
    changeActiveSlide(swiper, PAGE);
  });
  appSlider.on('transitionEnd', (swiper) => {
    changeActiveSlide(swiper, PAGE);
  });

  (() => {
    const crmSections = document.querySelectorAll('[data-crm-section]');
    const crmLists = document.querySelectorAll('[data-crm-list]');

    crmSections.forEach((section) => {
      section.addEventListener('click', () => {
        const sectionName = section.dataset.crmSection;

        crmSections.forEach((section) => {
          section.classList.remove('section--active');

          if (section.dataset.crmSection === sectionName) {
            section.classList.add('section--active');
          }
        });

        crmLists.forEach((list) => {
          const listName = list.dataset.crmList;
          list.classList.remove('active');

          if (listName === sectionName) {
            list.classList.add('active');
            list.querySelector('button').click();
          }
        });
      });
    });
  })();

  (() => {
    const tabletPicture = document.querySelector('[data-tablet-block]');
    const crmButtons = document.querySelectorAll('[data-crm-list-item] button');

    crmButtons.forEach((button) => {
      button.addEventListener('click', () => {
        tabletPicture.querySelector('.u_loader_wrap')?.remove();

        const sectionName = button.closest('[data-crm-list]').dataset.crmList;
        const pictureName = button.parentNode.dataset.crmListItem;

        crmButtons.forEach((button) => button.parentNode.classList.remove('active'));
        button.parentNode.classList.add('active');

        const loader = tabletPicture.querySelector('.u_loader_wrap');
        if (!loader) tabletPicture.innerHTML += LOADER;

        const tabletSource = tabletPicture.querySelector('source');
        const tabletImg = tabletPicture.querySelector('img');

        setTimeout(() => {
          loadPicture(tabletImg, tabletSource, `/img/pages/main/crm_tablet/${sectionName}/${pictureName}`)
            .then((img) => {
              tabletPicture.querySelector('.u_loader_wrap').remove();
            })
            .catch(() => {
              tabletPicture.querySelector('.u_loader_wrap').remove();
              console.warn('Image failed to load');
            });
        }, 750);
      });
    });
  })();

  (() => {
    const partnershipSections = document.querySelectorAll('[data-partnership-section]');
    const partnershipCaption = document.querySelector('[data-partnership-caption]');
    const partnershipPicture = document.querySelector('[data-partnership-picture]');

    partnershipSections.forEach((section) => {
      const sectionTitle = section.querySelector('[data-partnership-title]');

      sectionTitle.addEventListener('click', () => {
        const sectionCaption = sectionTitle.textContent;
        const sectionNumber = section.dataset.partnershipSection;

        partnershipSections.forEach((section) => section.classList.remove('active--desktop'));
        section.classList.toggle('active--phone');
        section.classList.add('active--desktop');

        partnershipCaption.textContent = sectionCaption;
        const loader = partnershipPicture.querySelector('.u_loader_wrap');
        if (!loader) partnershipPicture.innerHTML += LOADER;

        const partnershipSource = partnershipPicture.querySelector('source');
        const partnershipImg = partnershipPicture.querySelector('img');

        setTimeout(() => {
          loadPicture(partnershipImg, partnershipSource, `/img/pages/main/partnership/${sectionNumber}`)
            .then((img) => {
              partnershipPicture.querySelector('.u_loader_wrap').remove();
            })
            .catch(() => {
              partnershipPicture.querySelector('.u_loader_wrap').remove();
              console.warn('Image failed to load');
            });
        }, 750);
      });
    });
  })();
});

var isYoutubeLoaded = false;

const mediaSliderOptions = {
  slidesPerView: 2,
  spaceBetween: 24,
  watchSlidesProgress: true,

  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },

  breakpoints: {
    1001: {
      slidesPerView: 3,
    },
    769: {
      slidesPerView: 4,
    },
    601: {
      slidesPerView: 3,
    },
  },
};

const crmSliderOptions = {
  slidesPerView: 'auto',
  watchSlidesProgress: true,
  watchOverflow: true,
  slideToClickedSlide: true,
  centeredSlides: true,
};

const appSliderOptions = {
  slidesPerView: 'auto',
  watchSlidesProgress: true,
  watchOverflow: true,
  slideToClickedSlide: true,
  centeredSlides: true,
  spaceBetween: 12,
  initialSlide: 2,

  breakpoints: {
    601: {
      spaceBetween: 24,
    },
  },
};
